import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const cmsContentQuoteDefaultVariants = {}
const cmsContentQuoteCompoundVariants = []

const cmsContentQuoteSlotNames = [
  [
    "text",
    "cms-quote__text"
  ]
]
const cmsContentQuoteSlotFns = /* @__PURE__ */ cmsContentQuoteSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, cmsContentQuoteDefaultVariants, getSlotCompoundVariant(cmsContentQuoteCompoundVariants, slotName))])

const cmsContentQuoteFn = memo((props = {}) => {
  return Object.fromEntries(cmsContentQuoteSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const cmsContentQuoteVariantKeys = [
  "primary"
]
const getVariantProps = (variants) => ({ ...cmsContentQuoteDefaultVariants, ...compact(variants) })

export const cmsContentQuote = /* @__PURE__ */ Object.assign(cmsContentQuoteFn, {
  __recipe__: false,
  __name__: 'cmsContentQuote',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: cmsContentQuoteVariantKeys,
  variantMap: {
  "primary": [
    "true"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, cmsContentQuoteVariantKeys)
  },
  getVariantProps
})